import React from 'react'
import { DialogControl } from 'spark-core-dx/components';
import { useDashboardDomainContext } from '../../DashboardDomainProvider';

const CloseAllDialog = ({ isActive, closeDialog }) => {
    const {
        dashboardUserNavStateLib,
        setIsFilterFlyoutOpen,
    } = useDashboardDomainContext();

    return (
        <DialogControl
            className={"dashboard-dialog"}
            openDialog={isActive}
            title={"Close All Dashboards"}
            onOk={async () => {
                dashboardUserNavStateLib.closeAllDashboards();
                closeDialog();
                setIsFilterFlyoutOpen(false);
            }}
            onCancel={() => closeDialog()}
            okText={"Close All"}
        >
            <div className="dialog-text">
                Please confirm that you want to close all dashboards.
            </div>
        </DialogControl>
    )
}

export default CloseAllDialog